export interface PlanLimits {
  maxDomains: number;
  retentionDays: number;
  maxMessageBytes: number;
  dailyInboundCap: number;
}

/**
 * Plan limits. The beta values are [VERIFY] defaults: placeholders for the team
 * to confirm before launch, not validated figures.
 */
export const PLANS = {
  beta: {
    maxDomains: 3,
    retentionDays: 365,
    maxMessageBytes: 25 * 1024 * 1024,
    dailyInboundCap: 500,
  },
} as const satisfies Record<string, PlanLimits>;

export type PlanName = keyof typeof PLANS;

export function getPlanLimits(plan: string | null | undefined): PlanLimits {
  return plan && plan in PLANS ? PLANS[plan as PlanName] : PLANS.beta;
}

export type InboundCheck = { ok: true } | { ok: false; reason: "too_large" | "daily_cap" };

export function checkInboundAllowed({
  sizeBytes,
  todayCount,
  limits,
}: {
  sizeBytes: number;
  todayCount: number;
  limits: PlanLimits;
}): InboundCheck {
  if (sizeBytes > limits.maxMessageBytes) return { ok: false, reason: "too_large" };
  if (todayCount >= limits.dailyInboundCap) return { ok: false, reason: "daily_cap" };
  return { ok: true };
}
